var React = require('react');

function MoreVertical (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19,13H3V11H19L15,7L16.4,5.6L22.8,12L16.4,18.4L15,17L19,13M3,6H13V8H3V6M13,16V18H3V16H13Z"}));
}

MoreVertical.defaultProps = {"fill":"currentColor","version":"1.1","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = MoreVertical;

MoreVertical.default = MoreVertical;
